import axios, { AxiosResponse } from 'axios';

import { ApiResponse } from "../../interface/IResponse";


import { EmailFeedbackInput } from "../../interface/IPublic";



async function sendEmailFeedbackFunction(param: EmailFeedbackInput): Promise<AxiosResponse<ApiResponse<string>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Public/sendFeedbackEmail";

        const response: AxiosResponse<ApiResponse<string>> = await axios.post<ApiResponse<string>>(apiUrl, param, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}


const homeService = {
    sendEmailFeedback: sendEmailFeedbackFunction
}

export default homeService;